module.exports = __webpack_public_path__ + "img/27.391b77f7.png";